/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'news-feed-asset-acquistition': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="currentColor" stroke-width="2" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path pid="0" d="M14 8h-3v23h14V18"/><circle pid="1" cx="24" cy="8" r="7"/><path pid="2" d="M2 31h28M16 31v-8h4v8M11 18H6v12M15 18h6M15 14h1.5M24 5v6M21 8h6"/></g>'
  }
})
